import { PropsWithChildren } from 'react';
import { Box, FelaCSS } from '@bridebook/ui';
import mergeStyles from '../../../../fela-utils/merge-styles';
import { IStylingProps } from '../../../../themes/types';
import componentStyles from './h4.style';

interface IProps extends IStylingProps, PropsWithChildren {
  style?: FelaCSS;
}

/**
 * @deprecated
 * Use Text or DisplayText from bridebook/aura instead.
 */
const H4 = ({ style = {}, children, ...restProps }: IProps) => {
  const styles = componentStyles();

  return (
    <Box as="h4" style={mergeStyles([styles.wrapper, style])} data-name="h4" {...restProps}>
      {children}
    </Box>
  );
};

export default H4;
